import React from "react";

import {
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuList,
  Button,
  MenuItem,
  Box,
} from "@chakra-ui/react";

import { useDisclosure } from "@chakra-ui/react";

import { NavLink, Link } from "react-router-dom";

const NavItem = ({ item }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box position={"relative"}>
        <NavLink to={{ pathname: item.url }}>
          <Text
            fontWeight={"700"}
            fontSize={"1.8rem" }
            onMouseOver={() => onOpen()}
            onMouseLeave={() => onClose()}
            ml={"4rem"}
            textTransform={"uppercase"}
            color={"white"}
            _hover={{ color: "#EA0F0F" }}
            transition={"all 0.3s"}
          >
            {item.name}
            {item.subMenu ? (
              <i
                style={{ marginLeft: ".5rem" }}
                className="fas fa-caret-down"
              />
            ) : null}
          </Text>
        </NavLink>
        {isOpen && item.subMenu && (
          <Flex
            flexDir={"column"}
            width={"150%"}
            bg={"rgba(0,0,0,.5)"}
            position={"absolute"}
            onMouseOver={() => onOpen()}
            onMouseLeave={() => onClose()}
            p={"0 1.5rem"}
            pt=".5rem"
            pb={".5rem"}
            mx={"auto"}
          >
            {item.subMenu?.map((el, key) => {
              return (
                        <Link
                to={{ pathname: el.url, state: { id: el.id } }}
                onClick={() => {
                  onClose();
              
                  setTimeout(() => {
                    const element = document.querySelector(el.id);
              
                    if (element) {
                      element.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }, 50);
                }}
              >
                  <Text
                    fontWeight={"700"}
                    fontSize={ "1.5rem" }
                    textTransform={"uppercase"}
                    py={".5em"}
                    color={"white"}
                    _hover={{ color: "#EA0F0F" }}
                    transition={"all 0.3s"}
                    borderBottom={"1px solid white"}
                  >
                    {el.name}
                  </Text>
                </Link>
              );
            })}
          </Flex>
        )}
      </Box>
    </>
  );
};

export default NavItem;
